const KEY = 'foyerServiceStore';

export type PersistedFoyerServiceUi = {
    showService: boolean;
    activeServiceMenu: string | null;
    activeServiceMenuTitle: string | null;
};

export function getFoyerServiceStore(): PersistedFoyerServiceUi | null {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return null;

        const parsed = JSON.parse(raw) as Partial<PersistedFoyerServiceUi>;
        if (typeof parsed !== 'object' || parsed === null) return null;

        return {
            showService: !!parsed.showService,
            activeServiceMenu: parsed.activeServiceMenu ?? null,
            activeServiceMenuTitle: parsed.activeServiceMenuTitle ?? null,
        };
    } catch {
        return null;
    }
}

export function setFoyerServiceStore(next: PersistedFoyerServiceUi): void {
    try {
        localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
        // Ignore quota / privacy mode errors
    }
}

export function removeFoyerServiceStore(): void {
    try {
        localStorage.removeItem(KEY);
    } catch {
        // Ignore
    }
}
